<template>
    <Layout>
        <!-- Start Contact Area  -->
        <div class="rwt-contact-area rn-section-gap">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 mb--40">
                        <SectionTitle text-align="center" subtitle="About Us" title="关于我们" />
                    </div>
                </div>
                <div class="row row--15 p-5">
                    <div class="col-lg-12">
                        <div class="rn-contact-address mt_dec--30">
                            <div class="col-12">
                                <div class="rn-address">
                                    上海澜栗信息技术有限公司致力于企业福利/礼品定制平台，集研发、设计、销售为一体的新锐礼品公司，专注于礼品行业数年。企业本着“诚信做人，踏实做事，高效高质完成客户要求”的企业精神，广泛服务于社会大型  企业、银行、保险、地产等上市公司。公司在竞争激烈的市场稳中求进、立志创新，逐步打造出一支专业精良、 思想前进、德才具备的企业团队，每一步都会最大程度的站在客户的立场上为客户着想，力求每一份由澜栗设计生产出的礼品都能够成为高水准、效率高的企业礼品。目前公司主要产品分为数码电子、生活日用、皮具  箱包、办公文具、户外运动、工艺礼品等实用性礼品。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Separator />
                <div class="row p-5">
                    <div class="col-lg-12 mb--40">
                        <SectionTitle text-align="center" subtitle="Contact Form" title="联系我们" />
                    </div>
                </div>
                <div class="row row--15">
                    <div class="col-lg-12">
                        <div class="rn-contact-address mt_dec--30">
                            <div class="row">
                                <div class="col-lg-4 col-md-6 col-12">
                                    <div class="rn-address">
                                        <div class="icon">
                                            <Icon name="headphones" :size="40" />
                                        </div>
                                        <div class="inner">
                                            <h4 class="title">联系电话</h4>
                                            <p><a href="tel:+8618521530797">18521530797</a></p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6 col-12">
                                    <div class="rn-address">
                                        <div class="icon">
                                            <Icon name="mail" :size="40" />
                                        </div>
                                        <div class="inner">
                                            <h4 class="title">邮箱地址</h4>
                                            <p><a href="mailto:candy.lu@lanli.cc">candy.lu@lanli.cc</a></p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6 col-12">
                                    <div class="rn-address">
                                        <div class="icon">
                                            <Icon name="map-pin" :size="40" />
                                        </div>
                                        <div class="inner">
                                            <h4 class="title">公司地址</h4>
                                            <p>上海市静安区闻喜路930弄14号101室</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt--40 row--15">
                    <!-- 先不展示表单 -->
                    <!-- <div class="col-lg-7">
                        <ContactForm />
                    </div> -->
                    <!-- <div class="col-lg-5 mt_md--30 mt_sm--30">
                        <AMap />
                    </div> -->
                    <div class="col-lg-12 mt_md--30 mt_sm--30">
                        <AMap />
                    </div>
                </div>
            </div>
        </div>
        <!-- End Contact Area  -->
    </Layout>
</template>

<script>
import Layout from '../components/common/Layout'
import Breadcrumb from '../components/elements/breadcrumb/Breadcrumb'
import SectionTitle from '../components/elements/sectionTitle/SectionTitle'
import Icon from "../components/icon/Icon";
import AMap from "../components/elements/contact/Amap";
import ContactForm from "../components/elements/contact/ContactForm";
import Separator from '../components/elements/separator/Separator'

export default {
    name: 'ContactPage',
    components: { ContactForm, AMap, Icon, SectionTitle, Breadcrumb, Layout, Separator }
}
</script>